/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import PropTypes from 'prop-types';
import { pillarStyling } from './styling';
import React from 'react';

const InnerPillar = (
  { styling, scaledVersionStyling, sideStylingLeft, sideStylingRight },
  ref,
) => {
  return (
    <div css={[pillarStyling, styling]} style={scaledVersionStyling} ref={ref}>
      <span css={sideStylingLeft} />
      <span css={sideStylingRight} />
    </div>
  );
};

InnerPillar.propTypes = {
  styling: PropTypes.string,
  sideStylingLeft: PropTypes.string,
  sideStylingRight: PropTypes.string,
  scaledVersionStyling: PropTypes.object,
  showScaledVersion: PropTypes.bool,
  ref: PropTypes.oneOfType([
    // Either a function
    PropTypes.func,
    // Or the instance of a DOM native element (see the note about SSR)
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
};

export default React.forwardRef(InnerPillar);
